export default "__VITE_ASSET__886b1a24__"